import React, { forwardRef, useEffect, useImperativeHandle } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import { Controller, useForm } from 'react-hook-form'
import SydInput from '../../../../commonDesign/SydInput'

const useStyles = makeStyles((theme) => ({
  tagDisplay: {
    '& th': {
      backgroundColor: theme.palette.gray.main,
      padding: '10px',
      minWidth: '300px'
    },
    '& td': {
      padding: '10px',
      minWidth: '300px'
    },
    '& .__not-assigned': {
      color: theme.palette.gray.darker
    },
    '& .__remove-button': {
      textTransform: 'none'
    },
    '& .__select-option': {
      minWidth: '300px'
    },
    '& .__select-group': {
      display: 'flex',
      flexDirection: 'row',
      gap: '20px'
    }
  },
  group: {
    lineHeight: '50px',
    '& > *:first-child': {
      backgroundColor: theme.palette.gray.main
    }
  },
  groupType: {
    fontSize: theme.typography.fontSizes.xl,
    fontWeight: theme.typography.weights.semibold
  },
  groupName: {
    fontSize: theme.typography.fontSizes.xl,
    fontWeight: theme.typography.weights.light
  }
}))

const KdpDisplay = forwardRef(function KdpDisplay ({ datapoints, editing }, ref) {
  const classes = useStyles()
  const form = useForm({
    defaultValues: {
      datapoints
    }
  })
  useEffect(() => {
    if (!editing) {
      form.reset()
    }
  }, [editing, form])
  useImperativeHandle(ref, () => {
    return {
      form
    }
  }, [form])

  return (
    <table className={classes.tagDisplay}>
      <thead>
        <tr>
          <th>Kdp Code</th>
          <th>Kdp Name</th>
          <th>Kdp Value</th>
        </tr>
      </thead>
      <tbody>
        {(datapoints).map((kdp, i) => (
          <tr className={classes.group} key={kdp.code}>
            <td className={classes.groupType}>{kdp.codeName}</td>
            <td className={classes.groupType}>{kdp.displayName}</td>
            <td className={classes.groupName}>
              <Controller
                name={`datapoints.${i}.value`} control={form.control} render={(f) => (
                  <SydInput disabled={!editing} size='sm' {...f.field} />
                )}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
})

KdpDisplay.propTypes = {
  datapoints: PropTypes.array,
  editing: PropTypes.bool
}

KdpDisplay.defaultProps = {
  datapoints: [],
  editing: false
}

export default KdpDisplay
